module.exports = __webpack_public_path__ + "static/media/partitionBottomImg2.0c33f559.png";